import { Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/Aurora/twin-house/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/Aurora/twin-house/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/Aurora/twin-house/payment/PaymentPage';

const Index = () => {
  return (
    <>
      <Route exact path={`/sun_capital/master-plan/aurora/twin-house/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/aurora/twin-house/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/aurora/twin-house/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
